import React, { ReactElement } from 'react';
import classNames from 'classnames';
import { HistogramInterface } from 'modules/categories/interfaces/category-aggregations.interface';

import './histogram-item.scss';

const HistogramItem: React.FC<
    {
        min: number;
        max: number;
        item: HistogramInterface;
        count: number;
    }
    > = ({ item, count, min, max }): ReactElement | null => {
        const containerStyles = {
            height: 30,
            width: 20,
            margin: '0px 1px'
        };

        const columnStyles = {
            height: `${(Math.log2(item.count) * 100 + 50) / Math.log2(count + 50)}%`,
            width: 20
        };

        return (
            <div className="histogram-item" style={containerStyles}>
                <div
                    className={classNames({
                        'histogram-item__column': true,
                        'histogram-item__column--active': min <= item.min && max >= item.max
                    })}
                    style={columnStyles}
                />
            </div>
        );
    };

export default HistogramItem;
